import ResponsiveTypography from '@/components/ui/responsive-typography';
import {Multimedia} from '@/types/matrix';
import {Box, Card, CardMedia} from '@mui/material';

import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';
interface BoxWithMoreThanFiveElementsProps {
  urls: string[];
  multimediaType: Multimedia;
  handleOpenFullScreen: (url: string) => void;
}
const BoxWithMoreThanFiveElements: React.FC<
  BoxWithMoreThanFiveElementsProps
> = ({urls, multimediaType, handleOpenFullScreen}) => {
  const cardProps = {
    height: '100%',
    objectFit: 'cover'
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: '100%'
  };

  const isVideo = multimediaType === 'video';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        //gap: '5px',
        maxWidth: {xs: '150px', md: '300px'},
        maxHeight: {xs: '125px', md: '250px'}
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
          //gap: '5px'
        }}
      >
        {urls.slice(0, 2).map((url, index) => (
          <Box
            key={url}
            sx={{
              height: {xs: '75px', md: '150px'},
              width: {xs: '75px', md: '150px'},
              position: 'relative'
            }}
          >
            <Card sx={{...cardProps}}>
              {isVideo ? (
                <VideoPreviewWithPlayIcon
                  url={urls[index]}
                  handleOpenFullScreen={handleOpenFullScreen}
                />
              ) : (
                <CardMedia
                  component="img"
                  image={urls[index]}
                  alt={`${multimediaType} ${index + 1}`}
                  onClick={() => handleOpenFullScreen(urls[index])}
                  sx={{...cardMediaProps}}
                />
              )}
            </Card>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
          //gap: '5px'
        }}
      >
        {urls.slice(2, 5).map((url, index) => (
          <Box
            key={url}
            sx={{
              height: {xs: '50px', md: '100px'},
              width: {xs: '50px', md: '100px'},
              position: 'relative'
            }}
          >
            <Card sx={{...cardProps}}>
              {isVideo ? (
                <VideoPreviewWithPlayIcon
                  url={urls[index + 2]}
                  handleOpenFullScreen={handleOpenFullScreen}
                />
              ) : (
                <CardMedia
                  component="img"
                  image={urls[index + 2]}
                  alt={`${multimediaType} ${index + 3}`}
                  onClick={() => handleOpenFullScreen(urls[index + 2])}
                  sx={{...cardMediaProps}}
                />
              )}

              {index === 2 && urls.length > 5 && (
                <Box
                  onClick={() => handleOpenFullScreen(urls[index + 2])}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    //pointerEvents: 'none',
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  <ResponsiveTypography
                    medium
                    sx={{
                      color: 'white',
                      textShadow: '1px 1px 2px black'
                      //pointerEvents: 'auto'
                    }}
                  >
                    +{urls.length - 5}
                  </ResponsiveTypography>
                </Box>
              )}
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BoxWithMoreThanFiveElements;
